import { useCallback, useEffect, useState } from 'react';
import * as React from 'react';
import { useQueryParamString } from 'react-use-query-param-string';
import styled from 'styled-components';

import { TRACKING_LABELS } from '@/utils';

import { FullScreenVideo } from '../global/FullScreenVideo';

import { LoomVideo } from './LoomVideo';

const Video = styled.div`
  ${({ theme }) => theme.card};
  position: relative;
  max-height: 590px;
  aspect-ratio: 16 / 9;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    max-height: 235px;
  }
`;

interface BlogPostHeroMediaVideoProps {
  url: string;
}

export const BlogPostHeroMediaVideo: React.ComponentType<BlogPostHeroMediaVideoProps> =
  React.memo(({ url }) => {
    const [openVideoParam] = useQueryParamString('openVideo', '');
    const [isFullScreenVideoOpen, setIsFullScreenVideoOpen] = useState(false);

    useEffect(() => {
      setIsFullScreenVideoOpen(openVideoParam === 'true');
    }, [openVideoParam]);

    const _handleCloseVideo = useCallback(() => {
      setIsFullScreenVideoOpen(false);
    }, []);

    const src = url + '&enablejsapi=1&version=3';

    return (
      <Video>
        <FullScreenVideo
          embed={
            <iframe
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen={true}
              frameBorder="0"
              height="720"
              src={src}
              title="blog hero video"
              width="1280"></iframe>
          }
          isOpen={isFullScreenVideoOpen}
          path=""
          trackingLabel={TRACKING_LABELS.VideoPlayed}
          onClose={_handleCloseVideo}
        />
        <LoomVideo src={src} />
      </Video>
    );
  });
